import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

export default function LandingNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="bg-transparent fixed top-0 left-0 right-0 z-50 mb-8">
      <div className="mx-auto max-w-screen-lg px-0 sm:px-6 lg:px-0">
        <div className="flex h-16 items-center justify-between bg-white rounded-bl-lg rounded-br-lg p-4 shadow-lg">
          <div className="md:flex md:items-center md:gap-12">
            <Link className="text-teal-600 flex flex-row" to="/">
              <span className="sr-only">Home</span>
              <img src="/logo.png" className="w-52" alt="DrillFlo logo" />
            </Link>
          </div>

          <div className="hidden md:block">
            <nav aria-label="Global">
              <ul className="flex items-center gap-6 text-sm">
                <li>
                  <a
                    className="text-gray-900 font-medium text-lg transition hover:text-gray-500/75"
                    href="https://www.drillflo.com/about"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    className="text-gray-900 font-medium text-lg transition hover:text-gray-500/75"
                    href="https://help.drillflo.com/"
                  >
                    Support
                  </a>
                </li>
                <li>
                  <a
                    className="text-gray-900 font-medium text-lg transition hover:text-gray-500/75"
                    href="https://www.drillflo.com/blog"
                  >
                    Blog
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div className="flex items-center gap-4">
            <div className="sm:flex sm:gap-4">
              <Link
                className="rounded-md bg-blue-700 px-5 py-2.5 text-sm font-medium text-white shadow"
                to="/login"
              >
                Login
              </Link>
              <div className="hidden sm:flex">
                <Link
                  className="rounded-md bg-gray-100 px-5 py-2.5 text-sm font-medium text-blue-600"
                  to="/register"
                >
                  Register
                </Link>
              </div>
            </div>

            <div className="block md:hidden">
              <button
                onClick={toggleMenu}
                className="rounded bg-gray-100 p-2 text-gray-600 transition hover:text-gray-600/75"
                type="button"
                aria-label="Toggle menu"
              >
                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="size-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                  animate={isMenuOpen ? { rotate: 90 } : { rotate: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  {isMenuOpen ? (
                    <motion.path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.2 }}
                    />
                  ) : (
                    <motion.path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.2 }}
                    />
                  )}
                </motion.svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isMenuOpen && (
          <>
            <motion.div
              className="md:hidden fixed inset-0 bg-gray-800 bg-opacity-75 z-40"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={toggleMenu}
            />
            <motion.div
              className="md:hidden fixed top-20 left-4 right-4 bg-white rounded-2xl shadow-xl z-50 overflow-hidden"
              initial={{ opacity: 0, y: -20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -20, scale: 0.95 }}
              transition={{ duration: 0.3 }}
            >
              <nav aria-label="Mobile Global" className="p-4">
                <ul className="flex flex-col gap-4">
                  <li>
                    <a
                      className="block text-gray-900 font-medium text-lg transition hover:text-gray-500/75 py-2"
                      href="https://www.drillflo.com/about"
                      onClick={toggleMenu}
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      className="block text-gray-900 font-medium text-lg transition hover:text-gray-500/75 py-2"
                      href="https://help.drillflo.com/"
                      onClick={toggleMenu}
                    >
                      Support
                    </a>
                  </li>
                  <li>
                    <a
                      className="block text-gray-900 font-medium text-lg transition hover:text-gray-500/75 py-2"
                      href="https://www.drillflo.com/blog"
                      onClick={toggleMenu}
                    >
                      Blog
                    </a>
                  </li>
                  <li className="pt-2 border-t border-gray-200">
                    <Link
                      className="block w-full text-center rounded-md bg-blue-600 px-5 py-2.5 text-sm font-medium text-white shadow mb-2"
                      to="/login"
                      onClick={toggleMenu}
                    >
                      Login
                    </Link>
                    <Link
                      className="block w-full text-center rounded-md bg-gray-100 px-5 py-2.5 text-sm font-medium text-blue-600"
                      to="/register"
                      onClick={toggleMenu}
                    >
                      Register
                    </Link>
                  </li>
                </ul>
              </nav>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </header>
  );
}

